<div class="container">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="row" id="divTop" style="margin-top: 10px;margin-bottom: 10px;">
        <div class="col-md-9 col-xs-9">
          <div id="ButtonsTab" style="padding-left:5px;">
            <button id="btnExit" type="button" title="Exit" class="btn btn-primary" (click)="onExit()">
              <span>Exit</span>
            </button>

          </div>
        </div>
        <div class="col-md-3 col-xs-3" style="padding-right: 0px;">
          <div style="text-align: right;padding-right:5px;margin-top:20px;">
            <h6 style="color: #808080; font-size: 13px; font-style: oblique; font-weight:bold;"></h6>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="ErrorMessage.length > 0">
        <div class="col-md-12">
          <div style="font-size:small;">
            <img src="assets/img/error_icon.gif" /><span class="text-error" style="font-weight:bold;color:red;">
              The following errors were encountered on the page.
            </span>
          </div>
          <div id="divMainError" class="text-error"
            style="padding-top:0px; margin-bottom:10px;margin-left:25px; font-size:small; color:red">
            <span style="display:list-item" *ngFor="let item of ErrorMessage">{{item.message}}</span>
          </div>
        </div>
      </div>
      <div class="current-compensation-wrapper">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a style="color: gray; font-size: 14px;">
              <b>Initiate Record</b>
            </a>
          </h4>
        </div>
        <div style="height: 250px;">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-6">
                <div class="row" style="padding-top:7px;">
                  <div class="col-md-12">
                    <div class="row form-group">
                      <span class="col-sm-4"><b>Employee Name/GPN</b><span style="color: red;">*</span></span>
                      <div class="col-md-8 col-sm-8">
                        <p-autoComplete [(ngModel)]="EmployeeList.Employee" [suggestions]="filteredEmployeeSingle"
                          autocomplete="off" (completeMethod)="GetEmpSearch($event,false)" field="EmpFullName"
                          [size]="30" placeholder="Enter Name for Search" [minLength]="3"
                          aria-describedby="basic-addon3" name="Employee" (onClear)="OnClearSendUser()"
                          (onSelect)="SetSelectedEmpGPN($event)" [forceSelection]="true"
                          [style]="{'width':'100%', 'height':'40px','font-size': '14px'}"
                          [inputStyle]="{'width':'100%'}"></p-autoComplete>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row" style="padding-top:7px;">
                  <div class="col-md-12">
                    <div class="row form-group">
                      <div id="ButtonsTab">
                        <button id="btnGetResult" type="button" title="Get Result" class="btn btn-primary"
                          (click)="GetSearchFTERecord();">
                          <span class="hidden-xs">Get Result</span>
                        </button>
                        <button id="btnReset" type="button" title="Reset" class="btn btn-primary"
                          (click)="ResetResult();">
                          <span>Reset</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="ButtonsTab" style="padding-left:5px;"  *ngIf="this.IsNotExist">
            <button id="btnSubmit" type="button" title="Submit" class="btn btn-primary" [disabled]='this.isVisible'
              (click)="SubmitInitiateRecord('Initiate');">
              <span>Submit</span>
            </button>
             <button id="btnSubmit" type="button" title="Submit" class="btn btn-primary" [disabled]='this.isVisible'
              (click)="SubmitInitiateRecord('InitiateCounselor');">
              <span>Submit & Assign to Counselor</span>
            </button>
             <button id="btnExit" type="button" title="Exit" class="btn btn-primary" (click)="onExit()">
              <span>Exit</span>
            </button>
          </div>
        <br>
      <div class="employee-details-wrapper" *ngIf="this.IsNotExist">
        <div class="row">
          <div class="col-md-12">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a style="color: gray; font-size: 14px;">
                  <b>Employee Details</b>
                </a>
              </h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Employee LPN</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpLPN}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Employee GPN</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpGPN}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Employee Name</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpName}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Email ID</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpEmail}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Service Line</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.ServiceLine}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Title</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpTitle}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Location</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpLocation}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Office Address</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpOfficeAddress}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Counsellor</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpCouncelorName}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Manager</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpManagerName}}
                    </div>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Partner</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpPartnerName}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Joining Date</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpJoiningDate | date:"dd-MMM-yyyy"}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Mobile No.</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpMobile}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>CUG</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpCUG}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Legal Entity</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpLegalEntity}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Market Segment</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpBUDesc}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Status</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmpStatus}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Employee Type</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.EmployeeType}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Competency Name</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{InitiateRecord.CompetencyName}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="current-compensation-wrapper" *ngIf="this.IsNotExist">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a style="color: gray; font-size: 14px;">
              <b>Admin's Remarks</b>
            </a>
          </h4>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-md-6">
              <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Reason</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="textarea" id="txtReason" name="txtReason" maxlength="100" class="form-control"
                        [(ngModel)]="InitiateRecord.Reason" (keypress)="blockSpecialChar($event)" #txtReason="ngModel"
                        pattern="^[a-zA-Z0-9\s]*$" autocomplete="off">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Attachment</b></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="File" #fileInput id="" name="file" (change)="UploadAttachment($event)"
                        class="form-control" accept=".png,.jpeg,.msg,.pdf" style="width: 80%">
                      <span *ngIf="InitiateRecord.AttachmentName == ''">
                        No Attachments
                      </span>
                      <span>
                        <a (click)="GetAttachmentbyAttachmentID(InitiateRecord.AttachmentID,'InitiateRecord')"
                          style="cursor:pointer;color: blue;">{{InitiateRecord.AttachmentName}}</a>
                      </span>
                      <span style="color: blue; cursor: pointer; padding-left: 10px;"
                        *ngIf="InitiateRecord.AttachmentName != ''" (click)="DeleteAttachment()"
                        class="pi pi-trash"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Eligible as FTE</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <mat-checkbox [(ngModel)]="InitiateRecord.Eligible"></mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Revised Contract End Date</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <div class="input-group date">
                        <input matInput class="form-control" style="width: 250px; font-size: 14px;"
                          [matDatepicker]="RevisedContractEnd"  placeholder="Choose a date"
                          [(ngModel)]="RevisedContractEnd" (dateChange)="RevisedContractEndDateChange($event)" disabled>
                        <mat-datepicker-toggle matSuffix [for]="RevisedContractEnd">
                        </mat-datepicker-toggle>
                        <mat-datepicker #RevisedContractEnd [disabled]="false">
                        </mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="overlay">
  <p-progressSpinner styleClass="spinner" [style]="{width: '100px', height: '100px'}"></p-progressSpinner>
</div>
